export const AUTH_EXPIRED_EVENT = 'mcp-app:auth-expired';

export function emitAuthExpired(): void {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
}
